(() => {
  /**
   * Checks on an interval if jQuery is loaded.
   *
   * Reference source (https://stackoverflow.com/questions/7486309).
   *
   * @param {*} method - to run once the required libraries are loaded.
   * @param {Number} interval - lenght of time in ms to delay between required libaries check intervals.
   * @param {Number} timeout  - length of time in ms to stop libaries check after.
   * @param {Number} initialTime - Unix timestamp of initial check start.
   */
  function defer(
    method,
    interval = 50,
    timeout = 10000,
    initialTime = Date.now(),
  ) {
    if (window.jQuery) {
      method();
    } else if (Date.now() - initialTime > timeout) {
      console.warn(
        "Script defer timed out after " + timeout + "ms before executing!",
      );
    } else {
      setTimeout(function () {
        defer(method, interval, timeout, initialTime);
      }, interval);
    }
  }

  /**
   * Registers Availability-Tooltip variant change event listeners.
   */
  function registerAvailabilityTooltip() {
    if (
      !!availabilityVariantsMetadata &&
      !!availabilityStatusColors &&
      availabilityProductVariantsCount > 1
    ) {
      const productStatusDiv = $(document).find(".product_status");

      availabilitySelectCallback = function (variant) {
        if (!productStatusDiv.length) {
          console.warn(
            "Availability-Status-Tooltip variant change failed to execute on event because no product status div was found!",
          );
        } else if (!variant || !variant.sku) {
          console.warn(
            "Availability-Status-Tooltip variant change failed to execute on event because the selected variant passed was null!",
          );
          // Hide indicator if there is no availability set
          productStatusDiv.css("visibility", "hidden");
        } else {
          let variantStatus = availabilityVariantsMetadata[variant.sku].status;
          let variantLeadTime = availabilityVariantsMetadata[variant.sku].lead;

          // Pull default status and lead time if not set
          if (!variantStatus) {
            variantStatus = availabilityVariantsMetadata["default"].status;
            variantLeadTime = availabilityVariantsMetadata["default"].lead;
          }

          // Pull the matching border color
          let borderColor = availabilityStatusColors[variantStatus];

          // Set border color to default if non matching
          borderColor ??= availabilityStatusColors["Unknown"];
          if (borderColor == "undefined")
            borderColor = availabilityStatusColors["Unknown"];

          // Avoid showing redundant lead time in status text/tooltip (i.e. 'In Stock (In Stock)')
          if (
            variantLeadTime == variantStatus ||
            variantLeadTime == "In Stock" ||
            variantLeadTime == "Unknown"
          )
            variantLeadTime = null;

          let availability_text;
          let tooltip_text;

          if (!!variantStatus) {
            // If this variant has availability defined, change it
            if (!!variantLeadTime) {
              //Default tooltip text if not defined is the status text
              availability_text =
                variantStatus +
                " (" +
                variantLeadTime
                  .replace(/ /g, "\u00A0")
                  .replace(/-/g, "\u2011") +
                ")";
              tooltip_text = variantLeadTime + " Lead Time";
            } else {
              availability_text = variantStatus;
              tooltip_text = variantStatus;
            }

            // Find the required elements to change the availability/lead-time
            let productStatusTextDiv = $(document).find("#product_status_text");
            let productToolTipDiv = $(document).find(
              "#product_status_tooltip_text",
            );

            // Trim string texts and replace white spaces before displaying
            availability_text = availability_text.trim();
            tooltip_text = tooltip_text.trim();

            // Change the availability/lead-times if different
            if (productStatusTextDiv.text() != availability_text) {
              if (variantStatus === "In Stock") {
                productStatusTextDiv.html(
                  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#178200" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                    '<path d="M20 6 9 17l-5-5"></path>' +
                    "</svg> " +
                    availability_text,
                );
              } else {
                productStatusTextDiv.text(availability_text);
              }
            }
            if (productToolTipDiv.text() != tooltip_text)
              productToolTipDiv.text(tooltip_text);

            // Set border-color for indicator
            // Set border and text color for indicator
if (borderColor) {
  productStatusDiv.css("border-color", borderColor);
  productStatusDiv.css("color", borderColor);
}

            // Ensure that the indicator is visible
            productStatusDiv.css("visibility", "inherit");
          } else {
            // Hide indicator if there is no availability set
            productStatusDiv.css("visibility", "hidden");
          }
        }
      };

      document.addEventListener("variant:changed", function (event) {
        availabilitySelectCallback(event.detail.variant);
      });
    } else {
      console.error(
        "Availability-Status-Tooltip variant change listener failed to register due to missing or incorrect parameters!",
      );
    }
  }

  // Wait until DOM is loaded
  document.addEventListener("DOMContentLoaded", () => {
    defer(registerAvailabilityTooltip);
  });
})();
